import React, { ReactElement, useEffect } from 'react';
import { Form } from 'formik';
import { booleanOptions } from '../../../../../data/enumerations';
import FormRadio from '../../../../components/Form/FormRadio';
import { useDataCollection } from '../../../../../hooks';
import { InjectedWizardStepProps } from '../../../../components/Steps/WizardStep';
import StepHeader from '../../../../components/Layout/StepHeader';

const StepAtticHeatedBool = ({ completeStep }: InjectedWizardStepProps): ReactElement<'div'> | null => {
    const { handleChange, handleBlur, values } = useDataCollection();

    useEffect(() => {
        if (values.hasHeatedAttic) {
            completeStep && completeStep(true);
        }
    }, [values, completeStep]);

    return (
        <Form>
            <div className="otz-main otz-main--small">
                <StepHeader title="Půdu máte vytápěnou?" />
                <div className={'otz-main__grid'}>
                    {booleanOptions.map((option) => {
                        return (
                            <FormRadio
                                name="hasHeatedAttic"
                                value={option.value}
                                id={option.value}
                                label={option.title}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className={'wiz-form-radio--fullwidth wiz-form-radion--small m-b-0'}
                                checked={option.value === values.hasHeatedAttic}
                                key={option.value}
                            />
                        );
                    })}
                </div>
            </div>
        </Form>
    );
};

export default StepAtticHeatedBool;
